export default {
	DATE: /^\d{2}\/\d{2}\/\d{4}$/,
	DECIMAL: /^-?\d+\.\d{2}$/,
	DECIMAL_POSITIVE: /^\d+\.\d{2}$/,
	EMAIL: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
	INTEGER: /^-?\d+$/,
	INTEGER_POSITIVE: /^\d+$/,
	PHONE: /^\d{3}-\d{3}-\d{4}$/,
	ZIPCODE: /^\d{5}$/,
}